/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const GuardrailMode = {
  BanWords: "ban_words",
  PromptInjection: "prompt_injection",
  Leakage: "leakage",
} as const;
export type GuardrailMode = ClosedEnum<typeof GuardrailMode>;

/** @internal */
export const GuardrailMode$inboundSchema: z.ZodNativeEnum<
  typeof GuardrailMode
> = z.nativeEnum(GuardrailMode);
/** @internal */
export const GuardrailMode$outboundSchema: z.ZodNativeEnum<
  typeof GuardrailMode
> = GuardrailMode$inboundSchema;
